export default {
  theEmailIsNecessaryToSendYouTheTicketOrInvoices:
    "Die E-Mail ist notwendig, um Ihnen die Tickets oder Rechnungen zuzusenden.",
  enterTheAmountInKilograms: "Geben Sie den Betrag in Kilogramm ein",
  pleaseScanAValidQRCode: "Bitte scannen Sie einen gültigen QR-Code.",
  doYouWantToReceiveYourTicketInvoiceInYour:
    "Möchten Sie Ihr Ticket / Ihre Rechnung in Ihrem",
  whatDoYouWantToPay: "Was möchten Sie bezahlen?",
  noProductsLeftToPay: "Keine Produkte mehr zu bezahlen",
  totalSelected: "Gesamt ausgewählt :",
  error: "Fehler !",
  discard: "Verwerfen",
  thereIsNoOrderForTheTable: "Es gibt keine Bestellung für den Tisch",
  tableOrder: "Tischreihenfolge",
  invitation: "EINLADUNG",
  splitAccount: "Konto aufteilen",
  byProducts: "nach Produkten",
  cookingMeat: "FLEISCH GAREN",
  chooseYourDrink: "WÄHLEN SIE IHR GETRÄNK",
  chooseYourDishes: "Wählen Sie Ihre Gerichte",
  selectTheQRCodeOfTheTable: "Wählen Sie den QR-Code Ihres Tisches",
  oopsSelectYourTable: "Hoppla, wählen Sie Ihren Tisch aus",
  selectYourTable: "Wählen Sie Ihren Tisch",
  wellCooked: "Gut gekocht",
  toThePoint: "Auf den Punkt",
  underCooked: "Ungekocht",
  pleaseDecreaseTheQuantityOfProducts: "Bitte reduzieren Sie die Produktmenge",
  divide: "Teilen",
  among: "Unter",
  amountToPay: "Zu zahlender Betrag",
  amount: "Betragen",
  allTheProducts: "Alle Produkte",
  pleaseEnterValidAmount:
    "Bitte geben Sie einen gültigen Betrag von mehr als 0,50 € oder weniger als ein"
};
